import React from "react";
import { MdClose, MdOutlineFilterAlt } from "react-icons/md";
import Select from "react-select";
import MobileCustomDate from "./customDate/MobileCustomDate";
import BackDrop from "./BackDrop";
import useSelectedFinYear from "../../utils/selectedFinyear";
import MobileCustomDate1 from "./customDate/MobileCustomDate2";

const MobileFilter = ({
  filters,
  onApply,
  onClose,
  isFilter,
  setSelectedValues,
  selectedValues,
  nofinyearDate,
}) => {
  const {
    startFinDate,
    endFinDate,
    startFinYear,
    currentFinYear,
    currentDateStr,
  } = useSelectedFinYear();

  const handleSelectChange = (name, value) => {
    setSelectedValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (name, value) => {
    console.log("name::::", name, " | ", value);
    setSelectedValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (name, date) => {
    setSelectedValues((prev) => ({ ...prev, [name]: date }));
  };

  const handleApply = () => {
    onApply(selectedValues);
    onClose();
  };

  const handleClear = () => {
    setSelectedValues();
    onApply();
    onClose();
  };

  const getMin = (fallbackDate) => (nofinyearDate ? undefined : fallbackDate);
  const getMax = (fallbackDate, relatedDate) => {
    if (nofinyearDate) return undefined;
    if (relatedDate) return relatedDate;
    return currentFinYear === startFinYear ? currentDateStr : fallbackDate;
  };
  return (
    <div className={`sm:hidden`}>
      <div
        className={`fixed bottom-0 left-0 right-0 z-[900] rounded-t-lg bg-white p-4 shadow-lg ${
          isFilter ? " " : "  "
        }
          `}
      >
        <div className="mb-6 flex w-full items-center justify-between text-[#7c7c7c]">
          <h2 className=" flex items-center text-[22px] font-semibold text-[#7c7c7c]">
            <MdOutlineFilterAlt className={`text-[24px] text-[#7c7c7c] `} />
            Filter
          </h2>
          <MdClose className="cursor-pointer text-[30px]" onClick={onClose} />
        </div>
        <div className=" overflow-y-scroll">
          {filters?.map((filter) => (
            <div key={filter.name} className="mb-5">
              <label className="mb-1 block text-[17px] font-[500] text-[#7c7c7c]">
                {filter.label}
              </label>
              {filter.type === "searchable" || filter.type === "select" ? (
                <Select
                  options={filter.options}
                  onChange={(option) =>
                    handleSelectChange(filter.name, option?.value)
                  }
                  className="w-full rounded-md border-none text-[16px] text-[#7c7c7c] hover:border-none"
                  placeholder={`Select ${filter.label}`}
                  isSearchable={filter.type === "searchable"}
                  value={
                    selectedValues
                      ? filter?.options?.filter(
                          (item) => item.value === selectedValues[filter.name],
                        )
                      : null
                  }
                />
              ) : filter.type === "multi-select" ? (
                <Select
                  options={filter.options}
                  // onChange={(option) =>
                  //   handleMultiSelectChange(filter.name, option)
                  // }
                  isDisabled
                  styles={{
                    // Prevent the container from wrapping and allow horizontal scrolling
                    valueContainer: (provided) => ({
                      ...provided,
                      flexWrap: "nowrap",
                      overflowX: "auto",
                    }),
                    // Optionally adjust the multi-value container spacing
                    multiValue: (provided) => ({
                      ...provided,
                      marginRight: 4,
                    }),
                    // Optionally, remove extra height if needed
                    control: (provided) => ({
                      ...provided,
                      minHeight: "40px",
                    }),
                  }}
                  // value={
                  //   selectedValues && selectedValues[filter.name]
                  //     ? filter.options.filter((option) =>
                  //         selectedValues[filter.name].some(
                  //           (selected) => selected.value === option.value,
                  //         ),
                  //       )
                  //     : null
                  // }
                  isMulti
                  className="w-full rounded-md border-none"
                  // className="w-full rounded-md border-none text-[16px] text-[#7c7c7c] hover:border-none"
                  placeholder={`Select ${filter.label} (Development in progress)`}
                  isSearchable={filter.type === "searchable"}
                />
              ) : filter.type === "date from" ? (
                <MobileCustomDate
                  setHandleSetValue={(date) =>
                    handleDateChange(filter.name, date)
                  }
                  value={selectedValues?.date_from}
                  initialValue={selectedValues?.date_from}
                  // min={startFinDate}
                  // max={
                  //   selectedValues && selectedValues?.date_to
                  //     ? selectedValues?.date_to
                  //     : currentFinYear === startFinYear
                  //     ? currentDateStr
                  //     : endFinDate
                  // }
                  min={getMin(startFinDate)}
                  max={getMax(endFinDate, selectedValues?.date_to)}
                />
              ) : filter.type === "date from 2" ? (
                <MobileCustomDate
                  setHandleSetValue={(date) =>
                    handleDateChange(filter.name, date)
                  }
                  value={selectedValues?.date_from_2}
                  initialValue={selectedValues?.date_from_2}
                  // min={startFinDate}
                  // max={
                  //   selectedValues && selectedValues?.date_to_2
                  //     ? selectedValues?.date_to_2
                  //     : currentFinYear === startFinYear
                  //     ? currentDateStr
                  //     : endFinDate
                  // }
                  min={getMin(startFinDate)}
                  max={getMax(endFinDate, selectedValues?.date_to_2)}
                />
              ) : filter.type === "date to" ? (
                <MobileCustomDate1
                  setHandleSetValue={(date) =>
                    handleDateChange(filter.name, date)
                  }
                  value={selectedValues?.date_to}
                  initialValue={selectedValues?.date_to}
                  // min={
                  //   selectedValues && selectedValues?.date_from
                  //     ? selectedValues?.date_from
                  //     : startFinDate
                  // }
                  // max={
                  //   currentFinYear === startFinYear
                  //     ? currentDateStr
                  //     : endFinDate
                  // }
                  min={
                    nofinyearDate
                      ? undefined
                      : selectedValues?.date_from || startFinDate
                  }
                  max={
                    nofinyearDate
                      ? undefined
                      : currentFinYear === startFinYear
                      ? currentDateStr
                      : endFinDate
                  }
                />
              ) : filter.type === "date to 2" ? (
                <MobileCustomDate1
                  setHandleSetValue={(date) =>
                    handleDateChange(filter.name, date)
                  }
                  value={selectedValues?.date_to_2}
                  initialValue={selectedValues?.date_to_2}
                  // min={
                  //   selectedValues && selectedValues?.date_from_2
                  //     ? selectedValues?.date_from_2
                  //     : startFinDate
                  // }
                  // max={
                  //   currentFinYear === startFinYear
                  //     ? currentDateStr
                  //     : endFinDate
                  // }
                  min={
                    nofinyearDate
                      ? undefined
                      : selectedValues?.date_from_2 || startFinDate
                  }
                  max={
                    nofinyearDate
                      ? undefined
                      : currentFinYear === startFinYear
                      ? currentDateStr
                      : endFinDate
                  }
                />
              ) : null}
            </div>
          ))}
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleApply}
            className="w-full rounded bg-orange-500 p-2 text-white"
          >
            Apply
          </button>
          <button
            onClick={handleClear}
            className="w-full rounded border-[1px] border-orange-500 bg-white p-2 text-orange-500"
          >
            Clear Filter
          </button>
        </div>
      </div>
      <BackDrop closeHandler={onClose} />
    </div>
  );
};

export default MobileFilter;
